// extracted by mini-css-extract-plugin
export default {"centerAlign":"column_centerAlign__kAqWP","displayFlex":"column_displayFlex__Y0gEp","noTextCursor":"column_noTextCursor__M6P4r"};